module.exports = __webpack_public_path__ + "img/describe_image.a267629b.png";